import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=408c257c&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('408c257c', component.options)
    } else {
      api.reload('408c257c', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=408c257c&", function () {
      api.rerender('408c257c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesCompra/VerDetalleModal.vue"
export default component.exports